import { forwardRef, HTMLAttributes } from 'react';

import { cn } from '../../lib/utils/cn';

/**
 * A simple wrapper component that applies flexbox layout.
 * Main goal is to improve code readability.
 * Passes all the props, ref and className.
 *
 * @example
 * <Flex className="gap-4">
 *   <div>Item 1</div>
 *   <div>Item 2</div>
 * </Flex>
 */

export const Flex = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn('flex', className)} {...props} />,
);
Flex.displayName = 'Flex';
